import dayjs from 'dayjs';

import type { ChipIntent } from '@/components/common/chip';

import type { OrderStatus } from './types';

/** Order Date & Time: local display of the UTC wire value (ADR-0007). */
export function formatOrderDateTime(iso: string): string {
  return dayjs(iso).format('D MMM YYYY | hh:mm A');
}

/** Delivery Date: plain date, `-` when null (story 102117). */
export function formatDeliveryDate(value: string | null): string {
  return value ? dayjs(value).format('D MMM YYYY') : '-';
}

/** Status label + Figma colorway (chip intents verified: approved=green, published=blue,
 *  wip=amber, attention=red), keyed on the wire enum. */
export const ORDER_STATUS_CHIP: Record<OrderStatus, { label: string; intent: ChipIntent }> = {
  order_placed: { label: 'Order Placed', intent: 'wip' },
  shipped: { label: 'Shipped', intent: 'published' },
  delivered: { label: 'Delivered', intent: 'approved' },
  cancelled: { label: 'Cancelled', intent: 'attention' },
};

/** Expected/Delivery date display: `Mon DD, YYYY` (e.g. Jan 12, 2026); `-` when unset. */
export function formatDetailDate(value: string | null): string {
  return value ? dayjs(value).format('MMM DD, YYYY') : '-';
}

/** The delivery field flips label once the order is delivered (102123). */
export function deliveryFieldLabel(status: OrderStatus): string {
  return status === 'delivered' ? 'Delivery Date' : 'Expected Delivery Date';
}
